import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { checkAuthentication } from '../utils/authService';
import Loader from './Loader';

const ProtectedRoute = ({ children }) => {
  const [authStatus, setAuthStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const status = await checkAuthentication();
        setAuthStatus(status);
      } catch (error) {
        console.error('Auth check error:', error);
        setAuthStatus({ isAuthenticated: false, offlineMode: false });
      } finally {
        setIsLoading(false);
      }
    };

    verifyAuth();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  const isAuthed = authStatus?.isAuthenticated || authStatus?.offlineMode;

  if (!isAuthed) {
    // Redirect to login with the current location as state
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute;

